import React from 'react';
import { CheckCircle, AlertTriangle, XOctagon } from 'lucide-react';
import { motion } from 'framer-motion';

const ConductStatus = ({ status = 'green', history = [] }) => {
    // status: 'green' | 'yellow' | 'red'

    const config = {
        green: {
            color: 'text-emerald-500',
            bg: 'bg-emerald-500',
            border: 'border-emerald-500',
            glow: 'shadow-emerald-500/20',
            label: 'Conduta Exemplar',
            icon: CheckCircle
        },
        blue: {
            color: 'text-blue-500',
            bg: 'bg-blue-500',
            border: 'border-blue-500',
            glow: 'shadow-blue-500/20',
            label: 'Novato / Treinamento',
            icon: CheckCircle
        },
        yellow: {
            color: 'text-amber-500',
            bg: 'bg-amber-500',
            border: 'border-amber-500',
            glow: 'shadow-amber-500/20',
            label: 'Atenção Necessária',
            icon: AlertTriangle
        },
        orange: {
            color: 'text-orange-500',
            bg: 'bg-orange-500',
            border: 'border-orange-500',
            glow: 'shadow-orange-500/20',
            label: 'Advertência Verbal',
            icon: AlertTriangle
        },
        red: {
            color: 'text-red-500',
            bg: 'bg-red-500',
            border: 'border-red-500',
            glow: 'shadow-red-500/20',
            label: 'Risco de Desligamento',
            icon: XOctagon
        },
        purple: {
            color: 'text-purple-500',
            bg: 'bg-purple-500',
            border: 'border-purple-500',
            glow: 'shadow-purple-500/20',
            label: 'Staff Destaque',
            icon: CheckCircle
        }
    };

    const currentCheck = config[status] || config.green;
    const Icon = currentCheck.icon;

    return (
        <div className="relative overflow-hidden rounded-2xl bg-zinc-900/50 border border-white/5 p-6 backdrop-blur-sm">
            {/* Background Glow */}
            <div className={`absolute -top-10 -right-10 w-32 h-32 rounded-full ${currentCheck.bg} opacity-10 blur-3xl`} />

            <div className="flex items-center justify-between mb-6 relative">
                <div>
                    <h3 className="text-zinc-400 text-xs font-bold uppercase tracking-widest mb-1">Status de Conduta</h3>
                    <div className={`flex items-center gap-2 ${currentCheck.color} drop-shadow-sm`}>
                        <Icon className="w-5 h-5" />
                        <span className="text-xl font-black italic">{currentCheck.label}</span>
                    </div>
                </div>

                {/* Traffic Light Visual */}
                <div className="flex gap-1.5 p-1.5 bg-black/40 rounded-full border border-white/5 shadow-inner">
                    {['purple', 'blue', 'green', 'yellow', 'orange', 'red'].map((light) => (
                        <motion.div
                            key={light}
                            initial={false}
                            animate={{
                                opacity: status === light ? 1 : 0.2,
                                scale: status === light ? 1.2 : 1
                            }}
                            className={`w-3 h-3 rounded-full ${config[light].bg} ${status === light ? `shadow-[0_0_10px_currentColor]` : ''}`}
                            title={config[light].label}
                        />
                    ))}
                </div>
            </div>

            {/* Warning History Mini-Graph */}
            <div className="flex items-end gap-1 h-8 mt-2 opacity-50">
                {Array.from({ length: 12 }).map((_, i) => (
                    <div key={i} className="flex-1 bg-zinc-800 rounded-t-sm h-full relative group">
                        {/* Fake history data mapping - just visual filler if history not provided */}
                        <div
                            className={`absolute bottom-0 w-full rounded-t-sm transition-all ${i > 9 ? 'bg-zinc-700 h-[80%]' : 'bg-zinc-700/50 h-[30%]'
                                }`}
                        />
                    </div>
                ))}
            </div>
            <p className="text-[10px] text-zinc-600 text-right mt-1 w-full uppercase font-medium">Histórico (12 Meses)</p>
        </div>
    );
};

export default ConductStatus;
